






























































































import Vue from "vue";
import iwSectionWithIcon from "@/encoding/components/layout/SectionWithIcon.vue";
import iwFacadeCount from "@/encoding/pages/questions/specifications/FacadeCount.vue";
import iwFloorArea from "@/encoding/pages/questions/specifications/FloorArea.vue";
import iwFacadeWidth from "@/encoding/pages/questions/specifications/FacadeWidth.vue";
import iwFloorCount from "@/encoding/pages/questions/specifications/FloorCount.vue";
import iwHasCaretakerOrConcierge from "@/encoding/pages/questions/specifications/HasCaretakerOrConcierge.vue";
import iwHasElevator from "@/encoding/pages/questions/specifications/HasElevator.vue";
import iwHasDisabledAccess from "@/encoding/pages/questions/specifications/HasDisabledAccess.vue";
import iwIsFirstOccupation from "@/encoding/pages/questions/specifications/IsFirstOccupation.vue";
import iwBuildingCondition from "@/encoding/pages/questions/specifications/BuildingCondition.vue";
import iwIsFurnished from "@/encoding/pages/questions/specifications/IsFurnished.vue";
import iwConstructionYear from "@/encoding/pages/questions/specifications/ConstructionYear.vue";
import iwHasParkingSpace from "@/encoding/pages/questions/specifications/HasParkingSpace.vue";
import iwHasDwellings from "@/encoding/pages/questions/specifications/HasDwellings.vue";
import iwHasOutBuildings from "@/encoding/pages/questions/specifications/HasOutBuildings.vue";
import iwIsPetAllowed from "@/encoding/pages/questions/specifications/IsPetAllowed.vue";
import iwNextPreviousButton from "@/encoding/components/NextPreviousButton.vue";
import { updateClassified, validationClassified } from "@/shared/scripts/ValidateData";
import { mapActions, mapState } from "vuex";
import iwHasGasWaterElectricityConnection from "@/encoding/pages/questions/specifications/HasGasWaterElectricityConnection.vue";
import iwSewerConnection from "@/encoding/pages/questions/specifications/SewerConnection.vue";


import { pushPageViewEvent } from "@/shared/store/modules/gtm/datalayer";

export default Vue.extend({

    components: {
        iwSectionWithIcon: iwSectionWithIcon,
        iwIsFirstOccupation: iwIsFirstOccupation,
        iwFacadeWidth: iwFacadeWidth,
        iwIsFurnished: iwIsFurnished,
        iwBuildingCondition: iwBuildingCondition,
        iwHasCaretakerOrConcierge: iwHasCaretakerOrConcierge,
        iwHasDisabledAccess: iwHasDisabledAccess,
        iwFacadeCount: iwFacadeCount,
        iwHasElevator: iwHasElevator,
        iwFloorArea: iwFloorArea,
        iwFloorCount: iwFloorCount,
        iwConstructionYear: iwConstructionYear,
        iwHasParkingSpace: iwHasParkingSpace,
        iwHasDwellings: iwHasDwellings,
        iwHasOutBuildings: iwHasOutBuildings,
        iwIsPetAllowed: iwIsPetAllowed,
        iwHasGasWaterElectricityConnection: iwHasGasWaterElectricityConnection,
        iwSewerConnection: iwSewerConnection,
        iwNextPreviousButton: iwNextPreviousButton
    },

    data: function() {
        return {
            isButtonDisabled: false as boolean
        };
    },

    computed: {
        ...mapState("FormModule", ["isEditionMode"]),
        isFacadeCountDisplayed: function(): boolean {
            return ["HOUSE", "APARTMENT", "COMMERCIAL", "OFFICE", "INDUSTRY", "OTHER"].indexOf(this.getPropertyType()) !== - 1;
        },
        hasFacadeWidth: function(): boolean {
            return ["HOUSE", "APARTMENT", "COMMERCIAL", "OFFICE", "INDUSTRY", "OTHER"].indexOf(this.getPropertyType()) !== - 1;
        },
        hasFloorArea: function(): boolean {
            return ["HOUSE","OFFICE","INDUSTRY","COMMERCIAL","APARTMENT","OTHER","HOMES_TO_BUILD"].indexOf(this.getPropertyType()) !== - 1;
        },
        hasBuildingCondition: function(): boolean {
            return ["HOUSE", "APARTMENT", "COMMERCIAL", "OFFICE", "INDUSTRY","GARAGE", "OTHER"].indexOf(this.getPropertyType()) !== - 1;
        },
        hasConstructionYear: function(): boolean {
            return ["HOUSE", "APARTMENT", "COMMERCIAL", "OFFICE", "INDUSTRY","GARAGE", "OTHER"].indexOf(this.getPropertyType()) !== - 1;
        },
        hasFloorCount: function(): boolean {
            return ["HOUSE", "APARTMENT", "COMMERCIAL", "OFFICE", "INDUSTRY", "OTHER"].indexOf(this.getPropertyType()) !== - 1;
        },
        hasDividerLine: function(): boolean {
            return this.isFacadeCountDisplayed &&
                this.hasFacadeWidth &&
                this.hasFloorArea &&
                this.hasBuildingCondition &&
                this.hasConstructionYear &&
                this.hasFloorCount;
        }
    },
    mounted: function() {
        pushPageViewEvent("classified_deposit_step5_general_info");
    },

    methods: {
        ...mapActions({
            goToPreviousStep: "StepsWizard/previous",
            goToNextStep: "StepsWizard/next"
        }),
        clickNext: function(){
            if (this.isEditionMode){
                this.isButtonDisabled = true;
                validationClassified((success:boolean) => {
                    Vue.nextTick(() => {
                        const inputsError = document.getElementsByClassName("input--error") as HTMLCollectionOf<HTMLElement>;
                        if (inputsError.length > 0) {
                            inputsError[0].focus();
                            window.scrollTo(0, 0);
                        }
                        this.isButtonDisabled = false;
                        this.goToNextStep();
                    });
                });
            } else {
                this.isButtonDisabled = true;
                updateClassified((success:boolean) => {
                    Vue.nextTick(() => {
                        const inputsError = document.getElementsByClassName("input--error") as HTMLCollectionOf<HTMLElement>;
                        if (inputsError.length > 0) {
                            inputsError[0].focus();
                            window.scrollTo(0, 0);
                        }
                        this.isButtonDisabled = false;
                        this.goToNextStep();
                    });
                });
            }
        },
        clickPrevious: function(){

            this.goToPreviousStep();
        }
    }
});
